import { useOrganization } from '@/contexts/OrganizationContext';
import { useApplyThemePreset } from './useApplyThemePreset';

/**
 * Applies the selected organization's theme preset (`data-theme` on the
 * document root — see `useApplyThemePreset`). Call this hook once from OrgLayout —
 * no provider needed.
 */
export function useOrgTheme() {
  const { selectedOrganization } = useOrganization();
  useApplyThemePreset(selectedOrganization?.theme_preset);
}
